export class AdvanceFilterConstants {
    public static readonly advanceFilterLocalStorage = `cpq_advanceFilter`; // The SAME key is used in Login.aspx
    public static readonly quickFilterSuffix = 'quick_filter';
    public static readonly pageSize = `datatable_page_size`;
    public static readonly orderBy = `datatable_order_by`;
    public static readonly productDataTableFilterLocalStorage = `product_product_data_table_component`;
}